module.exports = __webpack_public_path__ + "static/gallery-2@2x-f41ab617eb3e78e4cc3efcfa7cae34ba.jpg";